"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WRAPPED_SOL_MINT = exports.MAX_INPUT_LIMIT = exports.ROUTE_CACHE_DURATION = exports.MINIMUM_SOL_BALANCE = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.MINIMUM_SOL_BALANCE = 0.01;
exports.ROUTE_CACHE_DURATION = 20000;
exports.MAX_INPUT_LIMIT = 100000000000000;
exports.WRAPPED_SOL_MINT = new web3_js_1.PublicKey('So11111111111111111111111111111111111111112');
